import { render } from "./home-three-category.vue?vue&type=template&id=6f946a82"
import script from "./home-three-category.vue?vue&type=script&lang=js"
export * from "./home-three-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__